import PaginatedListState from 'flarum/common/states/PaginatedListState';
export default class FlagListState extends PaginatedListState {
  constructor(app) {
    super({}, 1, null);
    this.app = app;
  }
  get type() {
    return 'flags';
  }

  /**
   * Load flags into the application's cache if they haven't already
   * been loaded.
   */
  load() {
    if (this.app.session.user?.attribute('newFlagCount')) {
      this.pages = [];
      this.location = {
        page: 1
      };
    }
    if (this.pages.length > 0) {
      return Promise.resolve();
    }
    return super.loadNext();
  }
}
flarum.reg.add('flarum-flags', 'forum/states/FlagListState', FlagListState);